import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { getCurrentUser } from 'state/selectors'
import { Route, Redirect, withRouter } from 'react-router'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'
import MainHeaderNav from 'sections/main-header-nav'

import SingleTeamPeople from './single-team-people'
import SingleTeamProjects from './single-team-projects'
import ActivityList from 'components/activity-list/activity-list'

import {
    getTeamData,
    changeTitle,
    openModal
} from 'state/actions'

import {
    getUserRoles
} from 'state/selectors'

import { 
	getTeamSubtitleInfo
} from 'utils'

class SingleTeam extends Component {
    backToTeams = _ => {
        const newUrl = this.props.match.path.replace(':team_id', '')
        this.props.history.push(newUrl)
    }

    componentWillMount = _ => {
        this.props.getTeamData(this.props.team.id, _ => {
        })

        this.props.changeTitle(this.props.team.name)
    }

    componentWillUpdate = nextProps => {
        if(this.props.team && !nextProps.team){
            this.backToTeams()
        }else{
            if(this.props.team && nextProps.team && this.props.team.projectIds.length != nextProps.team.projectIds.length){
                this.props.getTeamData(nextProps.team.id, _ => {
                })
            }
        }
    }

	editTeam = _ => {
		this.props.openModal('edit', 'team', this.props.team)
	}

	deleteTeam = _ => {
		this.props.openModal('delete', 'team', this.props.team)
	}

    render() {
        const {
            team,
            location,
            match,
            allUsers,
            openModal,
            userRoles
        } = this.props

        if(!team){
            return (
                <div>
                    Loading
                </div>
            )
        }

        let canEditTeam = userRoles.admin || userRoles.pm

        this.navtabs = [
            {
                name: 'Activity',
                path: 'activity',
                component: ActivityList
            },{
                name: 'People',
                path: 'people',
                component: SingleTeamPeople
            },{
                name: 'Projects',
                path: 'projects',
                component: SingleTeamProjects
            }
        ]

        let subtitle = getTeamSubtitleInfo(team, allUsers)

        return (
            <div className="single-index">
                <header className="main-header">
                    <h1>
                        { team.name }
                    </h1>
                    <div className="sub-title-area">
                        <span>
                            { subtitle }
                        </span>
                    </div>
					<div className="button-area">
                        <Button 
                            size="small" 
                            label="Back to teams" 
                            icon="angle-left" 
                            callback={this.backToTeams} 
                        />
                        { canEditTeam ?
                            <Button 
                                size="small" 
                                label="Edit" 
                                icon="fe-edit-2" 
                                callback={this.editTeam} 
                            />
                        : null }
                        { canEditTeam ?
                            <Button 
                                size="small" 
                                label="Delete" 
                                icon="fe-trash-2" 
                                callback={this.deleteTeam} 
                            />
                        : null }
					</div>
					<MainHeaderNav 
						right={true} 
						relUrl={match.url} 
						callback={this.changeTeamTab} 
						navtabs={this.navtabs} 
                        type='routes'
						relUrl={match.url}
					/>
                </header>
                <main>
					<SwitchCSSTransitionGroup location={location} transitionName="slide" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
						{this.navtabs.map((object, i) => {
							return(
								<Route path={match.url+'/'+object.path} key={i} render={props => {
									let ThisComponent = object.component

									return (
										<ThisComponent 
                                            {...props} 
                                            context={'team'}
                                            team={team}
                                            openModal={openModal}
                                            canEditTeam={canEditTeam}
										/>
									);
								}} />
							)
						})}
						<Redirect from={match.url} exact to={match.url+'/projects'} />
					</SwitchCSSTransitionGroup>
                </main>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userData: getCurrentUser(state),
        allUsers: state.account.entities.users,
        team: state.account.entities.teams ? state.account.entities.teams[ownProps.match.params.team_id] : null,
        userRoles: getUserRoles(state),
    }
}

export default withRouter(connect(mapStateToProps, {
    getTeamData,
    changeTitle,
    openModal
})(SingleTeam))


// WEBPACK FOOTER //
// ./src/components/single-team/single-team.jsx